export function buildParams(page: string | number, search: string | null, date?: string | null) {
    const searchArg = search ? `&search=${search}` : '';
    const dateArg = date ? `&creation_month=${date}` : '';
    return `page=${page}${searchArg}${dateArg}`
}
